import React, { useState, useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation} from "react-router-dom";
import { Switch, Route, Redirect } from "react-router-dom";
import { loadMessages } from 'devextreme/localization';
import axios from "axios";
import { handleConcurrencyConflict, CONCURRENCY_HANDLED } from "./common/concurrency";
import data from "./assets/apiRoutes.json";
import Home from "./home/components/Home";
import TrackVisitedPages from "./home/components/TrackVisitedPages"
import NotAuthorized from "./home/components/NotAuthorized";
import Header from "./Header";
import Report from "./reports/components/Report";
import ABRReport from "./reports/components/ABRReport";
import ARTReportConfiguration from "./reports/components/ARTReportConfiguration";
import ReportGroups from "./security/reportGroups/ReportGroups";
import { LoadPanel } from 'devextreme-react/load-panel';
import DxTabPanel, { Item } from "devextreme-react/tab-panel";
import { Splitter, Item as SplitterItem } from "devextreme-react/splitter";
import SearchPage from "../src/home/components/SearchPage";

import * as PermissionsConstants from "./const/constants";

import TransactionSearchForm from "./wm/components/TransactionSearchForm";
import History from "./wm/components/History";
import Inventory from "./wm/components/transactions/inventory/Inventory";
import MockupV1 from "./wm/components/mockupv1";
import MockupV2 from "./wm/components/mockupv2";
import MockupV3 from "./wm/components/mockupv3";
import OMInventory from "./om/inventory/OMInventory";
import InventoryLotManagment from "./wm/components/transactions/inventory/InventoryLotManagment";
import OMInventoryLotManagment from "./om/inventory/OMInventoryLotManagment";
import InventorySubLotManagment from "./wm/components/transactions/inventory/InventorySubLotManagment";
import ImportData from "./wm/components/ImportData";
import WMScheduling from "./wm/components/scheduling/Scheduling";

import WMTransactionDataEntryList from "./wm/components/transactions/dataentry/list";
import WMTransactionDataEntryForm from "./wm/components/transactions/dataentry/form";
import WMddockdoorselection from "./dd/dockdoorselection";
import WMddockdoorstatus from "./dd/dockdoorstatus";
import ScheduleAppointment from "./dd/scheduleappointment";
import UnScheduleAppointment from "./dd/unscheduleappointment";
import OwnershipTransfer from "./wm/components/ownershiptransfer/OwnershipTransfer";
import OwnershipTransferInternal from "./wm/components/ownershiptransfer/OwnershipTransferInternal";
import MoveSublotInventory from "./wm/components/movesublotinventory/MoveSublotInventory";
import MoveSublotInventoryList from "./wm/components/movesublotinventory/MoveSublotInventoryList";
import WarehouseMap from "./wm/components/warehouse/WarehouseMap";

import { ReactComponent as ReceiptIcon } from "./assets/svg/receipt.svg";
import { ReactComponent as ShippmentIcon } from "./assets/svg/shippment.svg";
import { ReactComponent as AdjustmentIcon } from "./assets/svg/adjustment.svg";

import Update from "./so/components/update/Update";
import ReviewOrder from "./so/components/Pu_Processing/ReviewOrders/ReviewOrder";
import AddSeedLot from "./so/components/Maintenence/AddSeedLot";
import SelectDryStratMainPage from "./so/components/DryStrat/SelectDryStrat";
import PullOrderGrid from "./so/components/pullorder/PullOrder";
import EditTables from "./so/components/Maintenence/EditTables";
import EditSeedInventor from "./so/components/Maintenence/EditSeedInventor";
import MasterOrder from "./so/components/MasterRecords/MasterOrder";
import LotSelectList from "./so/components/Grid/LotSelectList";
import BareRootCalculator from "./so/components/Calculators/BareRoot";
import PlugCalculator from "./so/components/Calculators/PlugCalculator";
import StratComplete from "./so/components/StratComplete/StratComplete";
import ShipComplete from "./so/components/ShipComplete/ShipComplete";

import BagTags from "./so/components/Tags/BagTags";
import CutLotLabelBagTags from "./so/components/Tags/CutLotLabelBagTags";
import ManualBagTags from "./so/components/Tags/ManualBagTags";

import UserSecurityV2 from "./security/components/UserSecurityV2";
import ChangePassword from "./security/components/ChangePassword";
import UserDatabases from "./security/components/UserDatabases";

import LocationCodesGrid from "./tm/components/locationcodes/LocationCodesGrid"
import OrchardCodesGrid from "./tm/components/orchard/OrchardCodesGrid";
import BlockCodesGrid from "./tm/components/block/BlockCodesGrid";
import RametCodesGrid from "./tm/components/rametcodes/RametCodesGrid";
import AssetTags from "./tm/components/tags/AssetTags";
import ImportInspection from "./tm/components/transactions/inspection/ImportInspection";
import ExportInspection from "./tm/components/transactions/inspection/ExportInspection";
import InspectonTypes from "./tm/components/transactions/inspection/InspectonTypes";
import InventoryReports from "./tm/components/reports/InventoryReports";

import TreeviewSidebar from "./sidebar/treeviewSidebar";
import InspectionDetails from "./tm/components/transactions/inspection/InspectionDetailTabs";
import PrintInvoice from "./wm/components/printinvoice/PrintInvoice";

import OMTransaction from "./om/transaction/OMTransaction";
import SalesOrderManagement from "./om/transactions/salesorders/salesOrderManagement/SalesOrderManagement";
import SearchDashboard from "./dbl/searchdashboard";
import CreateDashboard from "./dbl/create-dashboard";
import UpdateDashboard from "./dbl/update-dashboard";
import DeleteDashboard from "./dbl/delete-dashboard";
import DBConfiguration from "./dbl/configuration";
import viewdashboard from "./dbl/view-dashboard";
import XmMonitor from "./xm/XmMonitor"
import OMTransactionHistoryMain from "./om/historicalTransaction/OMTransactionHistoryMain";
import OMTransactionHistoryMainDynamic from "./om/historicalTransactionDynamic/OMTransactionHistoryMainDynamic";
import UpdateOrderStage from "./om/transaction/processing/update-order-stage";
import CommitTransaction from "./om/transaction/commitTransactions/CommitTransaction";
import LoadIframe from "./ptr/LoadIframe"
import LoadChatIframe from "./ai/chat/components/Chat"

import DataSourceConfiguration from "./db/datasourceconfiguration";
import DevexpressDashboardConfiguration from "./db/dashboardconfiguration";
import ManageDashboard from "./db/ManageDashboard";
import CopyDashboard from "./db/CopyDashboard";
import ExportDashboard from "./db/ExportDashboard";
import ImportDashboard from "./db/ImportDashboard";
import SearchDataSource from "./db/searchdatasource";
import CreateDataSource from "./db/createdatasource";
import UpdateDataSource from "./db/updatedatasource";
import DeleteDataSource from "./db/deletedatasource";
import SearchDashboardDB from "./db/searchdashboard";
import ViewDxDashboard from "./db/ViewDxDashboard";
import AdjustAvailableUnAvailableStatus from "./wm/components/locationtracking/AdjustAvailableUnAvailableStatus"
import LocationManagement from "./wm/components/locationtracking/locationManagement/LocationManagement"
import LaborTrackingList from "./wm/components/laborTracking/List"
import LaborTrackingForm from "./wm/components/laborTracking/Form"
import TransferLotsToDifferentItems from "./wm/components/transactions/transferLotsToDifferentItems/TransferLotsToDifferentItems"
import TransferSubLotsToDifferentItems from "./wm/components/transactions/transferSubLotsToDifferentItems/TransferSubLotsToDifferentItems"
import TransactionsByCustomerList from "./reports/components/transactionsByCustomer/List"
import QueryOrdersByCustomerList from "./om/reports/queryOrdersByCustomer/List"
import ReplicateOMTransaction from "./om/transaction/replicateTransaction/replicate-transaction"
import AllocateAvailableQuantities from "./om/transaction/AllocateAvailableQuantities/AllocateAvailableQuantities"
import UpdatePrice from "./om/transaction/processing/update-price";
import GenerateCountRecords from "./im/gneratecountrecord/generate-record-count-imd0033"
import RecalculateKitUsage from "./im/processing/RecalculateKitUsage";
import WMUndoInvoices from "./wm/components/transactions/invoicing/UndoInvoices"
import WMCommitInvoices from "./wm/components/transactions/invoicing/ComitInvoices"
import WMGenerateInvoices from "./wm/components/transactions/invoicing/GenerateInvoices"
import WMTransactionManagement from "./wm/components/transactions/transactionmanagement/WMTransactionManagement"
import WMSchedulesManagement from "./wm/components/transactions/transactionScheduling/List"
import WMSchedulesManagementForm from "./wm/components/transactions/transactionScheduling/Form"
import WMCommitTransaction from "./wm/components/transactions/commitTransactions/WMCommitTransaction"
import UpdateTransactionsStage from "./wm/components/transactions/updateTransactionsStage/UpdateTransactionsStage"
import SearchInvoices from "./wm/components/invoices/SearchInvoices";
import UpdateInvoice from "./wm/components/invoices/UpdateInvoice";
import SearchCharges from "./wm/components/charges/List";
import ChargesForm from "./wm/components/charges/Form";
import GenerateStorageCharges from "./wm/components/charges/generateStorageCharges/GenerateStorageCharges";
import CalculateDeferredRevenue from "./wm/components/charges/calculateDeferredRevenue/CalculateDeferredRevenue";
import UpdateFreeDaysGracePeriods from "./wm/components/charges/updateFreeDaysGracePeriods/UpdateFreeDaysGracePeriods";
import GenerateRepeatingMiscCharges from "./wm/components/charges/generateRepeatingMiscCharges/GenerateRepeatingMiscCharges";
import TransferShipmentsToDispatch from "./wm/components/transactions/deliveryManagement/transferShipmentsToDispatch/TransferShipmentsToDispatch";
import PurgeNeverUsedRecords from "./wm/components/periodicTasks/itemCodes/purgeNeverUsedRecords/PurgeNeverUsedRecords";
import WMUnCommitTransactions from "./wm/components/transactions/uncommit/UnCommitTransactions"
import TwoFactorSettings from "./User/TwoFactorSettings ";
import CountResults from "./wm/components/transactions/inventory/CountResults";
import InventoryMain from "./mockup/dewarNurseriesInventory/InventoryMain";
import GenerateCountAdjustments from "./im/GenerateCountAdjustments";
import SchedulingTab from "./wm/components/transactions/dataentry/SchedulingTab";
import UpdateOrderDetailLot from "./om/transaction/processing/UpdateOrderDetailLot";
import AppSettings from "./security/AppSettings";
import ApiAuditLogs from "./security/components/ApiAuditLogs";
import List from "./id/common/list";
import ItemDataEntryList from "./wm/components/codes/itemDataEntry/List";
import ItemDataEntryForm from "./wm/components/codes/itemDataEntry/Form";
import DescriptiveCodesList from "./wm/components/codes/descriptiveCodes/List";
import DescriptiveCodesForm from "./wm/components/codes/descriptiveCodes/Form";
import ChargeCodeList from "./wm/components/codes/chargeCodeDataEntry/List";
import SerialNumberCodesList from "./wm/components/codes/serialNumberCodes/List";
import SerialNumberCodesForm from "./wm/components/codes/serialNumberCodes/Form";
import ChargeCodeForm from "./wm/components/codes/chargeCodeDataEntry/Form";
import RateCodeList from "./wm/components/codes/rateCodes/List";
import RateCodeForm from "./wm/components/codes/rateCodes/Form";
import RateScheduleCodeList from "./wm/components/codes/rateScheduleCodes/List";
import RateScheduleCodeForm from "./wm/components/codes/rateScheduleCodes/Form";
import WeekSettingsList from "./wm/components/codes/weekSettings/List";
import WeekSettingsForm from "./wm/components/codes/weekSettings/Form";
import CollectionCreditList from "./ar/components/collectionsCredit/List";
import CollectionCreditForm from "./ar/components/collectionsCredit/Form";
import ExceptionsList from "./wm/components/codes/exceptions/List";
import ExceptionsForm from "./wm/components/codes/exceptions/Form";
import ItemDataProfileList from "./wm/components/dataprofiles/itemDataProfile/List";
import ItemDataProfileForm from "./wm/components/dataprofiles/itemDataProfile/Form";
import ItemKitCodeList from "./wm/components/codes/itemKitCodes/List";
import ItemKitCodeForm from "./wm/components/codes/itemKitCodes/Form";
import OMItemDataEntryList from "./im/codes/itemDataEntry/List";
import OMItemDataEntryForm from "./im/codes/itemDataEntry/Form";
import OMLotDataEntryList from "./im/codes/lotDataEntry/List";
import OMLotDataEntryForm from "./im/codes/lotDataEntry/Form";
import LotDataEntryList from "./wm/components/codes/lotDataEntry/List";
import LotDataEntryForm from "./wm/components/codes/lotDataEntry/Form";
import SublotDataEntryList from "./wm/components/codes/subLotDataEntry/List";
import ManageEvaluationExpressionList from "./wm/components/codes/manageEvaluationExpression/List";
import ManageEvaluationExpressionForm from "./wm/components/codes/manageEvaluationExpression/Form";
import DynValChargeConfigList from "./wm/components/codes/dynamicEvalChargeConfig/List";
import DynValChargeConfigForm from "./wm/components/codes/dynamicEvalChargeConfig/Form";
import SubLotDataEntryForm from "./wm/components/codes/subLotDataEntry/Form";
import MainTab from "./id/codes/customerDataEntry/MainTab";
import IMTransactionEntryForm from "./im/InventoryManagement/TransactionEntryForm";
import IMEnterTransaction from "./im/transaction/list";
import IMTransactionForm from "./im/transaction/Form";
import ItemManagement from "./im/itemManagement/ItemManagement";
import InventoryOperation from "./im/InventoryManagement/InventoryOperation";
import WMItemKitProfilesList from "./wm/components/dataprofiles/itemKitProfile/List";
import WMItemKitProfileForm from "./wm/components/dataprofiles/itemKitProfile/Form";
import SearchTransactionProfiles from "./wm/components/dataprofiles/transactionDataProfile/List";
import WmTransactionProfilesPrimaryTab from "./wm/components/dataprofiles/transactionDataProfile/Form";
import ListGenericLookup from "./id/common/listGenericLookup";
import Form from "./id/codes/consigneeDataEntry/Form";
import RFMessages from "./rf/components/PeriodicTasks/messages/List";
import FormWarehouse from "./id/codes/warehouseDataEntry/Form";
import CarrierForm from "./id/codes/carrierDataEntry/Form";
import SalesOrderList  from "./om/transactions/salesorders/salesOrderDataEntry/List";
import SaledOrderForm from './om/transactions/salesorders/salesOrderDataEntry/Form'
import WMTransSetupForm from './wm/components/setup/configuration/Form'
import OMTransSetupForm from './om/setup/configuration/Form'
import OMProfile from './om/setup/dataProfiles/salesOrderProfileDataEntry/List'
import OMProfileForm from './om/setup/dataProfiles/salesOrderProfileDataEntry/Form'
import { ABECASUSER_LOGIN_TYPE } from "./common/permissions";
import {Enum, SourceTypes, TwoFactorAuthenticationSetting} from "./enum/Enum";
import LocationDataEntryList from "./im/codes/locationDataEntry/List";
import LocationDataEntryForm from "./im/codes/locationDataEntry/Form";
import CrateDataEntryList from "./im/codes/crateDataEntry/List";
import CrateDataEntryForm from "./im/codes/crateDataEntry/Form";
import OCR from "./poc/OCR";
import ChatSidebar from "./ai/chat/components/ChatSidebar";
import TaskQueueList from "./ta/taskQueue/List"
import OMDescriptiveCodesList from "./om/codes/descriptiveCodes/List";
import OMDescriptiveCodesForm from "./om/codes/descriptiveCodes/Form";
import IDSalesTaxCodeList from "./id/codes/salesTaxCode/List";
import IDSalesTaxCodeForm from "./id/codes/salesTaxCode/Form";
import OMTripsList from "./om/transactions/deliveryManagement/List"
import OMTripsForm from "./om/transactions/deliveryManagement/From"

import TransferDeliveriesToDispatch from "./om/transaction/deliveryManagement/TransferDeliveriesToDispatch";
import ExportEdiDocuments from "./om/transaction/exportEdiDocuments/ExportEdiDocuments";
import GenerateItemReorderRecords from "./po/transactions/requisitions/GenerateItemReorderRecords";
import VectorStoreDataEntryList from "./ai/vectorStoreDataEntry/List";
import VectorStoreDataEntryForm from "./ai/vectorStoreDataEntry/Form";
import FileDataEntryList from "./ai/fileDataEntry/List";
import FileDataEntryForm from "./ai/fileDataEntry/Form";
// filepath: c:\home\src\argos-repo\AbecasInsight\Argos.WebPortal\ClientApp\src\AppContainer.js


const position = { of: '#divContent' };
const SIDEBAR_DEFAULT_WIDTH = 250;
const SIDEBAR_MAX_WIDTH = 600;
const SIDEBAR_COLLAPSED_WIDTH = 47;
const SIDEBAR_MOBILE_BREAKPOINT = 768;


// Build the per-report routes from the raw DB report menu. ART (ABLAYOUT) reports load via
// /reports/run, so only compiled reports get a /{module}/reports/{name} route. Deduped by path.
const buildReportRoutes = (menu) => {
  const routesByPath = {};
  (menu || []).forEach((m) => {
    const mod = m && m.Module;
    if (!mod) return;
    (m.ReportGroupItems || []).forEach((it) => {
      if (!it || !it.Name || it.SourceTableName === "ABLAYOUT") return;
      const prefix = it.Name.slice(0, 2);  
      const path = `/${prefix.toLowerCase()}/reports/${it.Name}`;
      routesByPath[path.toLowerCase()] = {
        path,
        title: it.Description || it.ReportKey || it.Name,
        name: it.Name,
        fullName: it.Parameter || undefined,
        permission: it.Permission || null,
      };
    });
  });
  return Object.values(routesByPath);
};

// Report NAME (upper) -> gating permission value, for every report (compiled + ART), so
// /reports/run authorizes from the DB rather than a URL parameter.
const buildReportPerms = (menu) => {
  const perms = {};
  (menu || []).forEach((m) =>
    (m.ReportGroupItems || []).forEach((it) => {
      if (it && it.Name) perms[it.Name.toUpperCase()] = it.Permission || null;
    })
  );
  return perms;
};

const AppContainer = (props) => {
  var accessToken = props.oidc.user.access_token;
  const location = useLocation();
  const history = useHistory();
  const [sidebarMinimized, setSidebarMinimized] = React.useState(false);
  const [chatMenuRight, setChatMenuRight] = React.useState(false);
  const [filteredTabs, setFilteredTabs] = useState(null);
  const [permissions, setPermissions] = useState(null);
  // Report routes + permission map, derived from the raw DB menu the sidebar fetched once and
  // shared via Redux (props.reportMenu). reportPerms is null until the menu loads, so
  // /reports/run can wait before authorizing.
  const reportRoutes = useMemo(() => buildReportRoutes(props.reportMenu), [props.reportMenu]);
  const reportPerms = useMemo(
    () => (props.reportMenu == null ? null : buildReportPerms(props.reportMenu)),
    [props.reportMenu]
  );
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedTabIndex, _setSelectedTabIndex] = useState(() => {
    const saved = sessionStorage.getItem('wm_selectedTabIndex');
    return saved !== null ? parseInt(saved, 10) : 0;
  });
  const setSelectedTabIndex = useCallback((val) => {
    _setSelectedTabIndex(val);
    sessionStorage.setItem('wm_selectedTabIndex', val);
  }, []);
  const queryString = location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get('id');
  const customerId = urlParams.get('customerId');
  const rProfile = urlParams.get('RProfile');
  const recordType = urlParams.get('recordType');
  const profileCode = urlParams.get('profileCode');
  const rowid = urlParams.get('rowid');

  var TransactionTabs = [
    {
      id: 1,
      label: "Receipt",
      icon: ReceiptIcon,
      permission: PermissionsConstants.TransactionReceipt,
      component: TransactionSearchForm,
    },
    {
      id: 2,
      label: "Shipment",
      icon: ShippmentIcon,
      permission: PermissionsConstants.TransactionShipment,
      component: TransactionSearchForm,
    },
    {
      id: 3,
      label: "Adjustment",
      icon: AdjustmentIcon,
      permission: PermissionsConstants.TransactionAdjustment,
      component: TransactionSearchForm,
    },
  ];
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
      history.push("/wm/transaction")
    }
  }, []);


  const handleTabs = (e, val) => {
    setValue(val);
  };

  const minimizeSidebar = () => {
    setSidebarMinimized(!sidebarMinimized);
  };

  const fetchRolePermissions = () => {
    axios
      .get(
        `${window._env_.REACT_APP_AUTH_URL}/${data.idp.GetPermissionsByRole}?roleName=${props.oidc.user.profile.role}`
      )
      .then((res) => {
        let tabs = [];

        setPermissions(res.data);

        if (res.data.hasOwnProperty("TransactionReceipt")) {
          for (var i = 0; i < res.data.TransactionReceipt.length; i++) {
            if (res.data.TransactionReceipt[i] == 'Read') {
              tabs.push(TransactionTabs[0]);
              break;
            }
          }
        }

        if (res.data.hasOwnProperty("TransactionShipment")) {
          for (var i = 0; i < res.data.TransactionShipment.length; i++) {
            if (res.data.TransactionShipment[i] == 'Read') {
              tabs.push(TransactionTabs[1]);
              break;
            }
          }
        }

        if (res.data.hasOwnProperty("TransactionAdjustment")) {
          for (var i = 0; i < res.data.TransactionAdjustment.length; i++) {
            if (res.data.TransactionAdjustment[i] == 'Read') {
              tabs.push(TransactionTabs[2]);
              break;
            }
          }
        }

        /*
        for (let key in res.data) {
          TransactionTabs.map((link) => {
            if (key.includes(link.permission) && tabs.indexOf(link) < 0) {
              tabs.push(link);
            }
          });
        }
        */
        setFilteredTabs(tabs);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  useEffect(() => {
    
    if(props.oidc.user.profile.TwoFactorEnabled && props.oidc.user.profile.TwoFactorEnabled.toLowerCase() === "false")
    {
      const storedSettings = localStorage.getItem(PermissionsConstants.AppSettingsLocalStorageKey);
      if (storedSettings) 
      {
        var appSettings = JSON.parse(storedSettings);
        if(appSettings && appSettings.TwoFactorAuthenticationSetting && 
          ((appSettings.TwoFactorAuthenticationSetting == TwoFactorAuthenticationSetting.RequiredForAllInternalLogins && props.oidc.user.profile.LOGINTYPEID && props.oidc.user.profile.LOGINTYPEID == ABECASUSER_LOGIN_TYPE) || appSettings.TwoFactorAuthenticationSetting == TwoFactorAuthenticationSetting.RequiredForAllLogins || appSettings.TwoFactorAuthenticationSetting == TwoFactorAuthenticationSetting.RequiredForAllExternalLogins))
        {
          const currentAppUrl = window.location.href; 
          const identityAppUrl = `${window._env_.REACT_APP_AUTH_URL}/${data.idp.EnableTwoFactorAuthenticator}?method=2&currentUrl=${encodeURIComponent(currentAppUrl)}`;
          window.location.href = identityAppUrl;
        }
      }
    }

    axios.interceptors.response.use(
      (response) => {
          return response;
      },
      (error) => {
          if (error.response.status === 401) {
              history.push('/notauthorized');
          }

          // Optimistic concurrency: a stale save comes back as 409. Raise the blocking
          // "record changed - reload" dialog once, centrally, so no page has to handle it,
          // and flag the rejection so the page's own catch skips its red toast.
          if (handleConcurrencyConflict(error)) {
              error[CONCURRENCY_HANDLED] = true;
          }

          return Promise.reject(error);
      }
    );

    // Add an interceptor to include the token in the headers
    axios.interceptors.request.use(
      (config) => {
          const token = props.oidc.user.access_token; // Get the access token from your authentication mechanism
          if (token) {
              config.headers.Authorization = `Bearer ${token}`;
          }
          return config;
      },
      (error) => {
          return Promise.reject(error);
      }
    );

    axios.get(`${window._env_.REACT_APP_APIS}/${data.Localization.GetLocalizedMessages}`,
      {
        headers: {
          "Content-Type": "application/json",
          access_token: accessToken,
        }
      })
      .then((result) => {
        loadMessages(result.data);
        setLoading(false);
      });

    fetchRolePermissions();
  }, []);

  const onRedirectListingPage = () => {
    history.push("/wm/transaction");
  };
  function TabPanel(props) {
    const { children, value, index } = props;
    return value === index && <div>{children}</div>;
  }

  // Transition timing constants
  const TRANSITION_DURATION = '0.4s';
  const TRANSITION_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  const TRANSITION_DELAY = '0s';
  const OVERFLOW_TRANSITION_DURATION = '0.2s';
  const OVERFLOW_TRANSITION_DELAY = '0.15s';

  // Build transition strings using constants
  const sidebarTransition = `width ${TRANSITION_DURATION} ${TRANSITION_EASING} ${TRANSITION_DELAY}, min-width ${TRANSITION_DURATION} ${TRANSITION_EASING} ${TRANSITION_DELAY}, overflow ${OVERFLOW_TRANSITION_DURATION} ease ${OVERFLOW_TRANSITION_DELAY}`;
  const contentTransition = `margin-left ${TRANSITION_DURATION} ${TRANSITION_EASING} ${TRANSITION_DELAY}`;

  return (
    <div className="d-flex flex-column" style={{ height: '100vh', margin: 0 }}>
      <header className="argos-header">
        <Header minimizeSidebar={minimizeSidebar} />
      </header>
        <Splitter
          style={{ flex: 1, minHeight: 0 }}
        >
          <SplitterItem
            maxSize={SIDEBAR_MAX_WIDTH}
            size={sidebarMinimized ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_DEFAULT_WIDTH}
            resizable={true}
            collapsible={false}
          >
            <div
                className={sidebarMinimized ? "sidebarMinimized sideBarMenuePositionForMobile" : "theSidebar"}
                style={{
                    height: '100%',
                    width: sidebarMinimized ? '47px' : '100%',
                    borderRight: '1px solid #cccccc',
                    backgroundColor: '#fff',
                    overflowX: 'hidden',
                    overflowY: 'auto',
                }}
            >
              <TreeviewSidebar
                sidebarMinimized={sidebarMinimized}
                minimizeSidebar={minimizeSidebar}
                setChatMenuRight={setChatMenuRight}
              />
            </div>
          </SplitterItem>
          <SplitterItem>
            <div
              id="divContent"
              className={sidebarMinimized ? "sideBarMenueMarginLeft" : "sideBarMenueMarginLeft dimmed-content"}
              style={{
                backgroundColor: '#F6F7FB',
                padding: '10px',
                width: '100%',
                height: '100%',
                overflowY: 'hidden',
                position: 'relative',
                zIndex: 1,
              }}
            >
              <div
                className="AppContainerBorderStyle"
                style={loading || 
                      (location.pathname && location.pathname.toLowerCase().includes("/home")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/ai/chat")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/tm/codes/orchard-codes")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/tm/codes/block-codes")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/tm/codes/location-codes")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/tm/codes/ramet-codes")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/db/viewdashboard")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/dbl/management/viewdashboard")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/db/managedashboard")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/ptr/loadiframe")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/security/facilities")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/update")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/review-records")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/lot-select")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/dry-strat")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/strat-complete")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/ship-complete")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/bare-root")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/plugs")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/add-seedlot")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/edit-seed")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/edit-tables")) || 
                      (location.pathname && location.pathname.toLowerCase().includes("/so/reports/manualbagtags")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/reports/cutlotlabelbagtags")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/so/reports/bagtags")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/wm/mockupv1")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/wm/mockupv2")) ||
                      (location.pathname && location.pathname.toLowerCase().includes("/wm/mockupv3")) ?
                    {
                      border: "2.5px solid #e5e8f0",
                      borderRadius: "4px",
                      height: "100%",
                      flex: 1
                    } : 
                    {
                      border: "2.5px solid #e5e8f0",
                      borderRadius: "4px",
                      height: "100%",
                      flex: 1
                    }
                  }
              >
              <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={loading}
                showIndicator={true}
                shading={false}
                showPane={true}
                hideOnOutsideClick={false}
                position={position}
              />
            {loading ? (
              <div style={{ textAlign: "center", fontSize: "x-large", marginTop: "5px"}}>Loading Localization ...</div>)
              :
              (<>
                <TrackVisitedPages prefix={props.oidc.user.profile.identityId} />
                <Switch>

                <Route path="/home">
                  <Home>
                    <SearchPage />
                  </Home>
                </Route>
                <Route path="/poc/ocr">
                  <OCR />
                  </Route>
                  <Route exact path="/">
                    {props.oidc.user.profile.hasOwnProperty("LANDINGPAGE") && props.oidc.user.profile.LANDINGPAGE != null && props.oidc.user.profile.LANDINGPAGE != "" ? <Redirect to={props.oidc.user.profile.LANDINGPAGE} /> : <Redirect to="/home" />}
                  </Route>

                <Route path="/landingpage">
                  {
                    props.oidc.user.profile.hasOwnProperty("LANDINGPAGE") && props.oidc.user.profile.LANDINGPAGE != null && props.oidc.user.profile.LANDINGPAGE != "" ? <Redirect to={props.oidc.user.profile.LANDINGPAGE} /> : <Redirect to="/home" />
                  }
                </Route>
                <Route path="/notauthorized">
                  <NotAuthorized />
                </Route>

                  <Route path="/ar/reports/arr0008">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.Reports?.includes(PermissionsConstants.ReportsAgingReport) ? (
                      <Report Title="Aging Report" Name="ARR0008" />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/at/artreport/:id" component={ABRReport}>
                  </Route>
                  <Route path="/dbl/management/viewdashboard/:id" component={viewdashboard}>
                  </Route>
                  <Route path="/at/advancedreporttool">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.ATMenu?.includes(PermissionsConstants.ATMenuViewAdvancedReportTool) ? (
                      <ABRReport Title="Advanced Report Tool" Name="ABR0001" />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/scheduleappointment/:id">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.DockDoor?.includes(PermissionsConstants.DockDoorViewSelectionScreen) ? (
                      <ScheduleAppointment />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/unscheduleappointment/:id">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.DockDoor?.includes(PermissionsConstants.DockDoorViewSelectionScreen) ? (
                      <UnScheduleAppointment />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/at/configuration">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.ATMenu?.includes(PermissionsConstants.ATMenuViewARTConfiguration) ? (
                      <ARTReportConfiguration />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/so/update">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.SODMenu?.includes(PermissionsConstants.SodUpdateOrdersScreen) ? (
                      <Update />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/so/review-records">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.SODMenu?.includes(PermissionsConstants.SodReviewRecordsScreen) ? (
                      <ReviewOrder />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/so/lot-select">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.SODMenu?.includes(PermissionsConstants.SodLotSelectScreen) ? (
                      <LotSelectList />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/so/master-records">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.SODMenu?.includes(PermissionsConstants.SodLotMasterRecordsScreen) ? (
                      <MasterOrder />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}

                </Route>
                <Route path="/so/dry-strat">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodSelectDryStratScreen) ? (
                    <SelectDryStratMainPage />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/pullorder">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodPullOrderScreen) ? (
                    <PullOrderGrid />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/strat-complete">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodStratCompleteScreen) ? (
                    <StratComplete />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/ship-complete">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodShipCompleteScreen) ? (
                    <ShipComplete />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/add-seedlot">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodAddSeedLotsScreen) ? (
                    <AddSeedLot />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/edit-tables">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodEditTablesScreen) ? (
                    <EditTables />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/edit-seed">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodEditSeedInventoryScreen) ? (
                    <EditSeedInventor />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/bare-root">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodBareRootCalculatorScreen) ? (
                    <BareRootCalculator />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/plugs">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODMenu?.includes(PermissionsConstants.SodPlugsCalculatorScreen) ? (
                    <PlugCalculator />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/reports/bagtags">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODReports?.includes(PermissionsConstants.SodBagTagsReport) ? (
                    <BagTags />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/reports/cutlotlabelbagtags">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODReports?.includes(PermissionsConstants.SodCutLotLabelBagTagsReport) ? (
                    <CutLotLabelBagTags />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/so/reports/manualbagtags">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.SODReports?.includes(PermissionsConstants.SodManualBagTagsReport) ? (
                    <ManualBagTags />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/codes/location-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewLocationCodes) ? (
                    <LocationCodesGrid />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/codes/orchard-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewOrchardCodes) ? (
                    <OrchardCodesGrid />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/codes/block-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewBlockCodes) ? (
                    <BlockCodesGrid />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/codes/ramet-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewRametCodes) ? (
                    <RametCodesGrid />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/transactions/inspection">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewNewInspection) ? (
                    <InspectionDetails />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/transactions/printassettags">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewPrintAssetTags) ? (
                    <AssetTags />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/transactions/importinspections">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewImportInspections) ? (
                    <ImportInspection />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/transactions/exportinspections">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewExportInspections) ? (
                    <ExportInspection />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/transactions/inspectiontypes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewInspectionTypes) ? (
                    <InspectonTypes />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/tm/reports/inventoryreports">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TMMenu?.includes(PermissionsConstants.TMMenuViewInventoryReports) ? (
                    <InventoryReports />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transaction">
                  {filteredTabs == null ? (
                    <div></div>
                  ) : (filteredTabs.length == 0) ? (
                    <Redirect to="/NotAuthorized" />
                  ) : (
                    <DxTabPanel key={selectedTabIndex} onOptionChanged={onTabSelectionChanged} selectedIndex={selectedTabIndex}
                    >
                      {filteredTabs.map((m, i) => (
                        <Item key={i} title={m.label}>
                          <TransactionSearchForm permission={m.permission} setSelectedTabIndex={setSelectedTabIndex}/>
                        </Item>
                      ))}
                    </DxTabPanel>
                  )}

                </Route>
                <Route path="/wm/mockupv1">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewMockupV1) ? (
                    <MockupV1 />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/mockupv2">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewMockupV2) ? (
                    <MockupV2 />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/mockupv3">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewMockupV3) ? (
                    <MockupV3 />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/history">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.History != null ? (
                    <History />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/inventory-items">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.InventoryItems != null ? (
                    <Inventory />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/Inventory">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMInventory) ? (
                    <OMInventory />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/scheduling">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TransactionReceipt?.includes(PermissionsConstants.TransactionReceiptViewSchedulingInfo) ? (
                    <WMScheduling />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transactionmanagement">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMTransactionManagement) ? (
                    <WMTransactionManagement />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/CommitTransactions">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMCommitTransactions) ? (
                    <WMCommitTransaction />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/UpdateTransactionsStage">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMUpdateTransactionsStage) ? (
                    <UpdateTransactionsStage />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/searchinvoices">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewUpdateInvoices) ? (
                    <SearchInvoices />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/UpdateInvoice/:id">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewUpdateInvoices) ? (
                    <UpdateInvoice />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/search-charges">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewSearchCharges) ? (
                    <SearchCharges showPopup={{ visible: true }} title="Search Charges" />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/create-charges">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewSearchCharges) ? (
                    <ChargesForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/edit-charges">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewSearchCharges) ? (
                    <ChargesForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/generate-storage-charges">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewGenerateStorageCharges) ? (
                    <GenerateStorageCharges />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/calculate-deferred-handling-revenue">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewCalculateDeferredRevenue) ? (
                    <CalculateDeferredRevenue />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/update-free-days-grace-periods">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewUpdateFreeDaysGracePeriods) ? (
                    <UpdateFreeDaysGracePeriods />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/charges/generate-repeating-misc-charges">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewGenerateRepeatingMiscCharges) ? (
                    <GenerateRepeatingMiscCharges />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/delivery-management/transfer-shipments-to-dispatch">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewTransferShipmentsToDispatch) ? (
                    <TransferShipmentsToDispatch />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/periodic-tasks/item-codes/purge-never-used-records">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewPurgeNeverUsedRecords) ? (
                    <PurgeNeverUsedRecords />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/dbl/management">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBLMenu?.includes(PermissionsConstants.ManageDashboard) ? (
                    <SearchDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/dbl/configuration">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBLMenu?.includes(PermissionsConstants.DashboardConfiguration) ? (
                    <DBConfiguration />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/dbl/create-dashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBL?.includes(PermissionsConstants.CreateDashboardRole) ? (
                    <CreateDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/dbl/update-dashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBL?.includes(PermissionsConstants.UpdateDashboardRole) ? (
                    <UpdateDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/dbl/delete-dashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBL?.includes(PermissionsConstants.DeleteDashboardRole) ? (
                    <DeleteDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/datasourceconfiguration">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.DataSourceConfiguration) ? (
                    <DataSourceConfiguration />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/dashboardconfiguration">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.DevexpressDashboardConfiguration) ? (
                    <DevexpressDashboardConfiguration />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/ManageDashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.ManageDataSource) ? (
                    <ManageDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/CopyDashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.ManageDataSource) ? (
                    <CopyDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/ExportDashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.ManageDataSource) ? (
                    <ExportDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/ImportDashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.ManageDataSource) ? (
                    <ImportDashboard />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/ViewDashboard">
                  <ViewDxDashboard />
                </Route>
                <Route path="/wm/ownershiptransfer">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.OwnerShipTransferView) ? (
                    <OwnershipTransfer />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/internalownershiptransfer">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.OwnerShipTransferViewIOT) ? (
                    <OwnershipTransferInternal />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transferlotstodifferentitems">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.TransferLotsToDifferentItems) ? (
                    <TransferLotsToDifferentItems />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transfersublotstodifferentitems">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.TransferSublotsToDifferentItems) ? (
                    <TransferSubLotsToDifferentItems />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/move-sublot-inventory" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.MoveSublotInventoryView) ? (
                    <MoveSublotInventoryList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/move-sublot-inventory-move" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.MoveSublotInventoryView) ? (
                    <MoveSublotInventory />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transactiondataentry/create-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMTransactionDataEntry) ? (
                    <WMTransactionDataEntryForm  recordType={recordType} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transactiondataentry/edit-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMTransactionDataEntry) ? (
                    <WMTransactionDataEntryForm key={id || 'new'} id={id} recordType={recordType} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transactiondataentry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMTransactionDataEntry) ? (
                    <WMTransactionDataEntryList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/schedulesmanagement/edit-schedule">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMSchedulesManagement) ? (
                    <WMSchedulesManagementForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/schedulesmanagement/add-schedule">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMSchedulesManagement) ? (
                    <WMSchedulesManagementForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/schedulesmanagement">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMSchedulesManagement) ? (
                    <WMSchedulesManagement />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMTransaction) ? (
                    <OMTransaction />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/adjustavailableunavailablestatus">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.AdjustAvailableUnAvailableStatus) ? (
                    <AdjustAvailableUnAvailableStatus />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/locationmanagement">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.LocationManagement) ? (
                    <LocationManagement />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.LaborTrackingRoutes.Edit}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.EnterLaborTracking) ? (
                    <LaborTrackingForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.LaborTrackingRoutes.Create}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.EnterLaborTracking) ? (
                    <LaborTrackingForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.LaborTrackingRoutes.List}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.EnterLaborTracking) ? (
                    <LaborTrackingList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/history">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMTransaction) ? (
                    <OMTransactionHistoryMain />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/reports/query-orders-by-customer" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMReports?.includes(PermissionsConstants.OMReportsQueryOrdersByCustomer) ? (
                    <QueryOrdersByCustomerList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/dynamic-form">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMTransaction) ? (
                    <OMTransactionHistoryMainDynamic />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/transactions/salesorders/salesorder-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.SalesOrderDataEntry) ? (
                    <SalesOrderList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/om/transactions/salesorders/edit-salesorder">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.SalesOrderDataEntry) ? (
                    <SaledOrderForm id={id} RProfile={rProfile} recordType={recordType}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/om/transactions/salesorders/add-salesorder">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.SalesOrderDataEntry) ? (
                    <SaledOrderForm id={id}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/ptr/LoadIframe/:reportType" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.PTRMenu?.includes(PermissionsConstants.EarlyTagReport
                    || PermissionsConstants.DashboardManagement
                    || PermissionsConstants.PTRDailyUpdates
                    || PermissionsConstants.PTRDailyUpdates2
                    || PermissionsConstants.PTRConfiguration
                    || PermissionsConstants.PTROverrides
                    || PermissionsConstants.PTRAttributes
                    || PermissionsConstants.PTRRules
                    || PermissionsConstants.PTRCropRollTool
                    || PermissionsConstants.PTRSecurity) ? (
                    <LoadIframe />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/ai/chat" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : (<LoadChatIframe setSelectedTabIndex={setSelectedTabIndex}/>
                  )}
                </Route>
                <Route path="/db/searchdatasource">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.SearchDatasourceQuery) ? (
                    <SearchDataSource />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/searchdashboard">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DBMenu?.includes(PermissionsConstants.SearchDashboardQuery) ? (
                    <SearchDashboardDB />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/createdatasource">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DB?.includes(PermissionsConstants.CreateDatasourceQuery) ? (
                    <CreateDataSource />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/updatedatasource">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DB?.includes(PermissionsConstants.UpdateDatasourceQuery) ? (
                    <UpdateDataSource />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/db/deletedatasource">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DB?.includes(PermissionsConstants.DeleteDatasourceQuery) ? (
                    <DeleteDataSource />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/omcommittransaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMCommitTransaction) ? (
                    <CommitTransaction />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/replicateomtransaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMReplicateTransaction) ? (
                    <ReplicateOMTransaction />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
 
                <Route path="/om/AllocateAvailableQuantities">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.AllocateAvailableQuantities) ? (
                    <AllocateAvailableQuantities />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/genneratecountrecords">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.GeneratePhysicalInventoryCount) ? (
                    <GenerateCountRecords module='WM' />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/genneratecountrecords">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.GeneratePhysicalInventoryCount) ? (
                    <GenerateCountRecords module='IM' />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/undoinvoices">
                {permissions == null ? (
                  <div></div>
                ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuViewUndoInvoices) ? (
                  <WMUndoInvoices />
                ) : (
                  <Redirect to="/NotAuthorized" />
                )}
                </Route>
                <Route path="/wm/commitinvoices">
                 {permissions == null ? (
                   <div></div>
                 ) : permissions.WMMenu?.includes(PermissionsConstants.WMUnCommitTransactions) ? (
                   <WMCommitInvoices />
                 ) : (
                   <Redirect to="/NotAuthorized" />
                 )}
                </Route>
                <Route path="/wm/uncommittransactions">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMUnCommitTransactions) ? (
                    <WMUnCommitTransactions />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                  </Route>
                  <Route path="/wm/generateinvoices">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WMMenuGenerateInvoices) ? (
                    <WMGenerateInvoices />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                   
                  </Route>
                <Route path="/om/SalesOrderManagement">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.SalesOrderManagement) ? (
                    <SalesOrderManagement />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/dockdoorselection">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DockDoor?.includes(PermissionsConstants.DockDoorViewSelectionScreen) ? (
                    <WMddockdoorselection />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/dockdoorstatus">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DockDoor?.includes(PermissionsConstants.DockDoorViewStatusScreen) ? (
                    <WMddockdoorstatus />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/inventory-lots">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.InventoryItems != null ? (
                    <InventoryLotManagment />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/inventory-sublots">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.InventoryItems != null ? (
                    <InventorySubLotManagment />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/inventory-lots">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMInventory) ? (
                    <OMInventoryLotManagment />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/reports/wmr0046/:rowid/:companyid/:format">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Reports?.includes(PermissionsConstants.ReportsCustomerInvoiceReport) ? (
                    <PrintInvoice />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/reports/wmr0046/:rowid/:companyid">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Reports?.includes(PermissionsConstants.ReportsCustomerInvoiceReport) ? (
                    <PrintInvoice />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/reports/run" render={(rp) => {
                  const qp = new URLSearchParams(rp.location.search);
                  const name = qp.get("name");
                  const fullName = qp.get("fullName") || undefined;
                  const title = qp.get("title") || name;
                  const isArt = qp.get("art") === "1" || qp.get("source") === "ABLAYOUT";
                  if (!name) return <Redirect to="/home" />;
                  // Wait for both role permissions and the DB report-permission map to load.
                  if (permissions == null || reportPerms == null) return <div></div>;
                  // Permission comes from the DB (looked up by report name), never from the URL.
                  const perm = reportPerms[name.toUpperCase()];
                  if (perm && !Object.values(permissions).some((p) => Array.isArray(p) && p.includes(perm)))
                    return <Redirect to="/NotAuthorized" />;
                  const formatName = name.includes(":") ? name.split(":")[0] : name;
                  return isArt
                    ? <ABRReport key={name} Title={title} FormatName={formatName} />
                    : <Report key={name} Title={title} Name={name} FullName={fullName} />;
                }} />
                {(reportRoutes || []).map((r) => (
                  <Route key={r.path} path={r.path} exact>
                    {permissions == null ? (
                      <div></div>
                    ) : (!r.permission || Object.values(permissions).some((p) => Array.isArray(p) && p.includes(r.permission))) ? (
                      <Report Title={r.title} Name={r.name} FullName={r.fullName} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                ))}
                {/* Not DB report-group items: kept explicit. WMR0062/WMR0063 are not in the
                    report-group seed; omr0001 is an ungated special that loads OMR0002. */}
                <Route path="/wm/reports/WMR0062" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Reports?.includes(PermissionsConstants.ReportsWMItemStatusReport) ? (
                    <Report Title="Item Status Report" Name="WMR0062" />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/reports/WMR0063" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Reports?.includes(PermissionsConstants.ReportsWMEmptyLocationsReport) ? (
                    <Report Title="Empty Locations Report" Name="WMR0063" />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/reports/transactionsbycustomer" exact>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Reports?.includes(PermissionsConstants.ReportsQueryTransactionsByCustomer) ? (
                    <TransactionsByCustomerList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
            
                <Route path="/wm/reports/omr0001">
                  <Report Title="Packing Slip" Name="OMR0002" FullName="Argos.Report.OM.OMR0001, Argos.Report.OM" />
                </Route>
                <Route path="/wm/importdata">
                  {props.oidc.user.profile.hasOwnProperty("WMIMPORTFILES") && props.oidc.user.profile.WMIMPORTFILES == "Y" ? (
                    <ImportData />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/warehouse/map">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.WarehouseMap) ? (
                    <WarehouseMap />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/security/user-security">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Security?.includes(PermissionsConstants.SecurityRead) ? (
                    <UserSecurityV2 />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/security/facilities">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Security?.includes(PermissionsConstants.SecurityFacilities) ? (
                    <UserDatabases />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/security/change-password">
                  <ChangePassword />
                </Route>
                <Route path="/xm/xm-monitor">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.XMMenu?.includes(PermissionsConstants.ViewXmMonitor) ? (
                    <XmMonitor />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/update-order-stage">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMUpdateOrderStage) ? (
                    <UpdateOrderStage />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/update-price">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMUpdatePrice) ? (
                    <UpdatePrice />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/update-order-detail-lot">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMUpdateOrderDetailLot) ? (
                    <UpdateOrderDetailLot />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/security/two-factor-settings">
                  <TwoFactorSettings />
                </Route>
                <Route path="/security/report-groups">
                 {permissions == null ? (
                    <div></div>
                  ) : permissions.Security?.includes(PermissionsConstants.ReportGroup) ? (
                   <ReportGroups />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                  
                </Route>
                <Route path="/wm/enter-count-results">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.CountResults) ? (
                    <CountResults />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/generate-count-adjustments">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.WMMenu?.includes(PermissionsConstants.ViewCountAdjustments) ? (
                    <GenerateCountAdjustments module={'WM'} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/TransactionEntryForm">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMTransactionEntryForm) ? (
                    <IMTransactionEntryForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/EnterTransaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMEnterTransaction) ? (
                    <IMEnterTransaction />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/transaction/edit-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMEnterTransaction) ? (
                    <IMTransactionForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/transaction/add-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMEnterTransaction) ? (
                    <IMTransactionForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/itemManagement">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMItemManagement) ? (
                    <ItemManagement />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/InventoryOperation">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMTransactionEntryForm) ? (
                    <InventoryOperation id={id}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/processes/recalculate-kit-usage">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMRecalculateKitUsage) ? (
                    <RecalculateKitUsage />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/codes/location-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMLocationDataEntry) ? (
                    <LocationDataEntryList Module={PermissionsConstants.IM}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/codes/location-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMLocationDataEntry) ? (
                    <LocationDataEntryForm id={id} Module={PermissionsConstants.IM} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/im/codes/location-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.IMMenu?.includes(PermissionsConstants.IMLocationDataEntry) ? (
                    <LocationDataEntryForm id={id} Module={PermissionsConstants.IM} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/mockup/nurseries-inventory">
                  <InventoryMain />
                </Route>
                <Route path="/wm/scheduling-tab">
                  <SchedulingTab />
                </Route>
                <Route path="/security/app-settings">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Security?.includes(PermissionsConstants.ApplicationSettings) ? (
                    <AppSettings />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/security/api-audit-logs">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Security?.includes(PermissionsConstants.ApiAuditLogs) ? (
                    <ApiAuditLogs />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/customer-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCustomer) ? (
                    <List IdType='01'/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/consignee-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMConsignee) ? (
                    <List IdType='02'/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/carrier-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCarrier) ? (
                    <List IdType='05'/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/rf/periodictasks/rfmessages">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.PeriodicTasks?.includes(PermissionsConstants.RFMessages) ? (
                    <RFMessages />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-customer">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCustomer) ? (
                    <MainTab id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-customer">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCustomer) ? (
                    <MainTab id={id} IdType="01"/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-consignee">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMConsignee) ? (
                    <Form id={id} IdType="02" />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-consignee">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMConsignee) ? (
                    <Form id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-carrier">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCarrier) ? (
                    <CarrierForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-carrier">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCarrier) ? (
                    <CarrierForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/warehouse-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WarehouseDataEntry) ? (
                    <List IdType='06'/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/descriptive-codes-data-entry-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDescriptiveCode) ? (
                    <DescriptiveCodesList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/descriptive-codes-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDescriptiveCode) ? (
                    <DescriptiveCodesForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/descriptive-codes-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDescriptiveCode) ? (
                    <DescriptiveCodesForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                   <Route path="/wm/codes/edit-warehouse">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WarehouseDataEntry) ? (
                    <FormWarehouse id={id} IdType="06" />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-warehouse">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WarehouseDataEntry) ? (
                    <FormWarehouse id={id} IdType="06"/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/location-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMMenuLocationDataEntry) ? (
                    <LocationDataEntryList Module={PermissionsConstants.WM}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/serial-number/edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEditSerialNumberRecords) ? (
                    <SerialNumberCodesList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/serial-number/edit-record">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEditSerialNumberRecords) ? (
                    <SerialNumberCodesForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/serial-number/create-record">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEditSerialNumberRecords) ? (
                    <SerialNumberCodesForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/location-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMMenuLocationDataEntry) ? (
                    <LocationDataEntryForm id={id} Module={PermissionsConstants.WM} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/location-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMMenuLocationDataEntry) ? (
                    <LocationDataEntryForm id={id} Module={PermissionsConstants.WM} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>

                  <Route path="/wm/codes/item-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                    <ItemDataEntryList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/charge-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMChargeCode) ? (
                    <ChargeCodeList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-charge-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMChargeCode) ? (
                    <ChargeCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-charge-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMChargeCode) ? (
                    <ChargeCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/rate-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateCode) ? (
                    <RateCodeList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-rate-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateCode) ? (
                    <RateCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-rate-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateCode) ? (
                    <RateCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/rate-schedule-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateScheduleCode) ? (
                    <RateScheduleCodeList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-rate-schedule-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateScheduleCode) ? (
                    <RateScheduleCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-rate-schedule-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMRateScheduleCode) ? (
                    <RateScheduleCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/week-settings">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMWeekSettings) ? (
                    <WeekSettingsList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-week-settings">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMWeekSettings) ? (
                    <WeekSettingsForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-week-settings">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMWeekSettings) ? (
                    <WeekSettingsForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                {/* AR screen, so it is gated on the AR permission (ARMenu/CollectionCredit -
                    Permissions.ARMenuCollectionCredit), not on an OM sales-order permission:
                    an AR-only site has no OMMenu permissions at all. */}
                <Route path="/ar/collections/follow-up">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.ARMenu?.includes(PermissionsConstants.ARCollectionCredit) ? (
                    <CollectionCreditList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/ar/collections/edit-follow-up">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.ARMenu?.includes(PermissionsConstants.ARCollectionCredit) ? (
                    <CollectionCreditForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/ar/collections/add-follow-up">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.ARMenu?.includes(PermissionsConstants.ARCollectionCredit) ? (
                    <CollectionCreditForm id={id} customerId={customerId} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/exceptions">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMExceptions) ? (
                    <ExceptionsList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-exception">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMExceptions) ? (
                    <ExceptionsForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.ItemDataProfileRoutes.Edit}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemDataProfile) ? (
                    <ItemDataProfileForm id={rowid} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.ItemDataProfileRoutes.Create}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemDataProfile) ? (
                    <ItemDataProfileForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path={PermissionsConstants.ItemDataProfileRoutes.List}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemDataProfile) ? (
                    <ItemDataProfileList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-exception">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMExceptions) ? (
                    <ExceptionsForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/item-kit-codes">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemKitCode) ? (
                    <ItemKitCodeList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-item-kit-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemKitCode) ? (
                    <ItemKitCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-item-kit-code">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemKitCode) ? (
                    <ItemKitCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/lot-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMLotDataEntry) ? (
                    <LotDataEntryList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/sublot-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMSublotDataEntry) ? (
                    <SublotDataEntryList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/manage-evaluation-expression">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEvaluationExpression) ? (
                    <ManageEvaluationExpressionList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/dyn-eval-charge-config">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDynValChargeConfig) ? (
                    <DynValChargeConfigList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-dyn-eval-charge-config">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDynValChargeConfig) ? (
                    <DynValChargeConfigForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-dyn-eval-charge-config">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMDynValChargeConfig) ? (
                    <DynValChargeConfigForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-evaluation-expression">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEvaluationExpression) ? (
                    <ManageEvaluationExpressionForm/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/edit-evaluation-expression">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMEvaluationExpression) ? (
                    <ManageEvaluationExpressionForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                
                <Route path="/wm/codes/edit-item">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                    <ItemDataEntryForm id={id} recordType={recordType} RProfile={rProfile} profileCode={profileCode} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/codes/add-item">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                    <ItemDataEntryForm recordType={recordType} RProfile={rProfile} profileCode={profileCode} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>

                  <Route path="/wm/codes/edit-lot">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                      <LotDataEntryForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/wm/codes/add-lot">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                      <LotDataEntryForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>

                  <Route path="/wm/codes/edit-sublot">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                      <SubLotDataEntryForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/wm/codes/add-sublot">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.Codes?.includes(PermissionsConstants.WMItemDataEntry) ? (
                      <SubLotDataEntryForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>


                <Route path="/wm/codes/generic-lookup">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCustomer) ? (
                    <ListGenericLookup IdType='01'/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/DataProfiles/SearchTransactionProfiles">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMSearchTransactionPrf) ? (
                    <SearchTransactionProfiles />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>

                <Route path={PermissionsConstants.ItemKitProfileRoutes.Create}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemKitProfile) ? (
                    <WMItemKitProfileForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>

                <Route path={PermissionsConstants.ItemKitProfileRoutes.Edit}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemKitProfile) ? (
                    <WMItemKitProfileForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>

                <Route path={PermissionsConstants.ItemKitProfileRoutes.List}>
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMItemKitProfile) ? (
                    <WMItemKitProfilesList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                
                <Route path="/wm/transactionprofile/create-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMSearchTransactionPrf) ? (
                    <WmTransactionProfilesPrimaryTab />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/transactionprofile/edit-transaction">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.DataProfiles?.includes(PermissionsConstants.WMSearchTransactionPrf) ? (
                    <WmTransactionProfilesPrimaryTab id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/wm/setup/trans-num">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Setup?.includes(PermissionsConstants.WMTransNumSetup) ? (
                    <WMTransSetupForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/om/setup">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Setup?.includes(PermissionsConstants.OMSetup) ? (
                    <OMTransSetupForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/data-profiles/salesorder-profile-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMSalesOrderProfile) ? (
                    <OMProfile />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/data-profiles/salesorder-profile-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMSalesOrderProfile) ? (
                    <OMProfileForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/data-profiles/salesorder-profile-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMSalesOrderProfile) ? (
                    <OMProfileForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                 <Route path="/wm/codes/crate-data-entry">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCrateDataEntry) ? (
                    <CrateDataEntryList  Module={PermissionsConstants.WM}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                 <Route path="/wm/codes/crate-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.Codes?.includes(PermissionsConstants.WMCrateDataEntry) ? (
                    <CrateDataEntryForm id={id} Module={PermissionsConstants.WM}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                 <Route path="/ta/task-queue-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.TAMenu?.includes(PermissionsConstants.TaskQueue) ? (
                    <TaskQueueList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/item-data-entry-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMItemDataEntry) ? (
                    <OMItemDataEntryList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/item-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMItemDataEntry) ? (
                    <OMItemDataEntryForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/item-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMItemDataEntry) ? (
                    <OMItemDataEntryForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/lot-data-entry-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMLotDataEntry) ? (
                    <OMLotDataEntryList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/lot-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMLotDataEntry) ? (
                    <OMLotDataEntryForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/om/codes/lot-data-entry-create">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMCodes?.includes(PermissionsConstants.OMLotDataEntry) ? (
                      <OMLotDataEntryForm id={id} />
                    ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/descriptive-codes-data-entry-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMDescriptiveCodes) ? (
                    <OMDescriptiveCodesList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/om/codes/descriptive-codes-data-entry-edit">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMCodes?.includes(PermissionsConstants.OMDescriptiveCodes) ? (
                      <OMDescriptiveCodesForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/om/codes/descriptive-codes-data-entry-create">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMCodes?.includes(PermissionsConstants.OMDescriptiveCodes) ? (
                      <OMDescriptiveCodesForm />
                    ) : (
                        <Redirect to="/NotAuthorized" />
                      )}
                    </Route>
                <Route path="/om/codes/sales-tax-code-data-entry-list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMSalesTaxCodes) ? (
                    <IDSalesTaxCodeList />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/sales-tax-code-data-entry-edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMSalesTaxCodes) ? (
                    <IDSalesTaxCodeForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/codes/sales-tax-code-data-entry-create">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMCodes?.includes(PermissionsConstants.OMSalesTaxCodes) ? (
                    <IDSalesTaxCodeForm />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/transactions/delivery-management/list">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMTrips) ? (
                    <OMTripsList/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/transactions/delivery-management/edit">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.OMMenu?.includes(PermissionsConstants.OMTrips) ? (
                    <OMTripsForm id={id}/>
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                <Route path="/om/transactions/delivery-management/transfer-deliveries-to-dispatch">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMMenu?.includes(PermissionsConstants.OMTransferDeliveriesToDispatch) ? (
                      <TransferDeliveriesToDispatch />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/om/transactions/processing/generate-po-drop-ship-orders">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMMenu?.includes(PermissionsConstants.OMGeneratePODropShipOrders) ? (
                      <GenerateItemReorderRecords source ={SourceTypes.DropShip}/>
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/po/transactions/requisitions/generate-item-reorder-records">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.POMenu?.includes(PermissionsConstants.POGenerateRequisition) ? (
                      <GenerateItemReorderRecords source ={SourceTypes.Requisition}/>
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/om/transactions/export-edi-documents">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.OMMenu?.includes(PermissionsConstants.OMExportEdiDocuments) ? (
                      <ExportEdiDocuments />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/ai/vectorstore-data-entry">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewVectorStoreDataEntry) ? (
                      <VectorStoreDataEntryList />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/ai/edit-vectorstore">
                  {permissions == null ? (
                    <div></div>
                  ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewVectorStoreDataEntry) ? (
                    <VectorStoreDataEntryForm id={id} />
                  ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/ai/add-vectorstore">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewVectorStoreDataEntry) ? (
                      <VectorStoreDataEntryForm />
                    ) : (
                    <Redirect to="/NotAuthorized" />
                  )}
                </Route>
                  <Route path="/ai/file-data-entry">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewFileDataEntry) ? (
                      <FileDataEntryList />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/ai/edit-file">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewFileDataEntry) ? (
                      <FileDataEntryForm id={id} />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
                  <Route path="/ai/add-file">
                    {permissions == null ? (
                      <div></div>
                    ) : permissions.AIMenu?.includes(PermissionsConstants.AIMenuViewFileDataEntry) ? (
                      <FileDataEntryForm />
                    ) : (
                      <Redirect to="/NotAuthorized" />
                    )}
                  </Route>
              </Switch>
              {chatMenuRight && <ChatSidebar setSelectedTabIndex={setSelectedTabIndex}  />}

            </>
              )
            }
              </div>
            </div>
          </SplitterItem>
        </Splitter>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    oidc: state.oidc,
    // Raw DB report menu fetched once by the sidebar; AppContainer derives routes + perms from it.
    reportMenu: (state.ReceiptReducer && state.ReceiptReducer.reportMenu) || null,
  };
}
export default connect(mapStateToProps)(AppContainer);
